module.exports = __webpack_public_path__ + "static/media/network-rail-logo.3dfa2597.svg";